module.exports = __webpack_public_path__ + "img/bgi.8e4e0968.png";